import { call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessageString } from "utils/utils";
import apiService from "services/apiservice";
import { notificationController } from "components/common/notificationController";
import { loadState } from "library/helpers/sessionStorage";
import {
  FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST,
  FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST,
} from "./actionTypes";
import {
  fetchAllCustomersSuccess,
  fetchAllCustomersFailure,
  fetchAllVendorsSuccess,
  fetchAllVendorsFailure,
} from "./actions";
import { Customers, Vendors } from "./types";

const currentUser = loadState("loggedInUser");
const token = currentUser?.accessToken;

const postRequest = async (url: string, payload: any) => {
  const { data } = await apiService.post(url, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

function* fetchCustomersSaga(action: any) {
  try {
    const response: Customers[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = response.length > 0 ? response[0].totalCount : 0;
    yield put(fetchAllCustomersSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchAllCustomersFailure(errorMessage));

    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching customer list: ${errorMessage}`,
      });
    }
  }
}

function* fetchVendorsSaga(action: any) {
  try {
    const response: Vendors[] = yield call(
      postRequest,
      action.url,
      action.payload
    );

    const totalCount = response.length > 0 ? response[0].totalCount : 0;
    yield put(fetchAllVendorsSuccess(response, totalCount));
  } catch (error: any) {
    const errorMessage = getErrorMessageString(error);
    yield put(fetchAllVendorsFailure(errorMessage));

    if (errorMessage && error?.response?.status !== 401) {
      notificationController.error({
        message: "Error",
        description: `Error fetching vendor list: ${errorMessage}`,
      });
    }
  }
}

export default function* allCustomersVendorsSaga() {
  yield takeLatest(FETCH_ORDER_ENTRY_ALLCUSTOMERS_REQUEST, fetchCustomersSaga);
  yield takeLatest(FETCH_ORDER_ENTRY_ALLVENDORS_REQUEST, fetchVendorsSaga);
}
